// Header/index.js
import { connect } from 'react-redux';

import PersonnelsList from '../../components/PersonnelsList';

import {
  fetchAllPersonnelsDispatch,
  openEditPersonnelDialogDispatch,
  personnelEditClickDispatch,
  openCoursesForPersonnelDialog,
  clearAllCoursesForPersonnel,
  openDeletePersonnelDialogDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    personnels:
      state.personnels.allPersonnels && state.personnels.allPersonnels.items,
    branchId: state.branch.branch.item && state.branch.branch.item.id
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllPersonnels: (branchId) => {
      dispatch(fetchAllPersonnelsDispatch(branchId));
    },
    onPersonnelEditClick: (personnel) => {
      dispatch(openEditPersonnelDialogDispatch(true));
      dispatch(personnelEditClickDispatch(personnel));
    },
    onOpenCoursesForPersonnelDialog: (open, personnel) => {
      dispatch(clearAllCoursesForPersonnel());
      dispatch(openCoursesForPersonnelDialog(open, personnel));
    },
    onOpenDeletePersonnelDialog: (open, personnel) => {
      dispatch(openDeletePersonnelDialogDispatch(true));
      dispatch(personnelEditClickDispatch(personnel));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelsList);
